var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-loading",style:({'background': _vm.showLoad ? this.colors.splashBg : '#transparent'})},[_c('div',{staticClass:"loading"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.showIcon),expression:"showIcon"}],staticClass:"loading__anim"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }